"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePrevious;
var _react = require("react");
/**
 * @typedef {*} usePreviousResponse
 * @property {*} - The previous value.
 */

/**
 * Hook used to store the previous state of a variable.
 * @function usePrevious
 * @example
 * const prevValue = usePrevious(someValue);
 * @returns {usePreviousResponse} - The previous value.
 */
function usePrevious(value) {
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}